import { Action } from '../../../types/Action';
import { IPreownedApr } from '../../../types/PreownedRate';
import {
  SET_IS_PREOWNED_RATES_UPDATED,
  SET_PREOWNED_RATES,
  SET_PREWOWNED_RATES_FILTER,
  UPDATED_PREWOWNED_RATES,
  UPDATED_PREWOWNED_RATES_FILTER,
} from './PreownedAprRatesActionTypes';

interface PreownedRatesState {
  preownedAprs: IPreownedApr[];
  isPreOwnedRatesDataUpdated: boolean;
  updatedPreownedAprs: IPreownedApr[];
  preownedAprsFilter: { model: string[]; trim: string[] };
  updatedpreownedAprsFilter: { model: string[]; trim: string[] };
}

export const initialPreownedRatesState: PreownedRatesState = {
  preownedAprs: [],
  isPreOwnedRatesDataUpdated: false,
  updatedPreownedAprs: [],
  preownedAprsFilter: { model: [], trim: [] },
  updatedpreownedAprsFilter: { model: [], trim: [] },
};

export const preownedRatesReducer = (
  state = initialPreownedRatesState,
  action: Action,
): PreownedRatesState => {
  switch (action.type) {
    case SET_PREOWNED_RATES:
      return {
        ...state,
        preownedAprs: action.payload,
      };
    case SET_IS_PREOWNED_RATES_UPDATED:
      return {
        ...state,
        isPreOwnedRatesDataUpdated: action.payload,
      };
    case UPDATED_PREWOWNED_RATES:
      return {
        ...state,
        updatedPreownedAprs: action.payload,
      };
    case SET_PREWOWNED_RATES_FILTER:
      return {
        ...state,
        preownedAprsFilter: action.payload,
      };
    case UPDATED_PREWOWNED_RATES_FILTER:
      return {
        ...state,
        updatedpreownedAprsFilter: action.payload,
      };
    default:
      return state;
  }
};
